import {styled} from "@mui/material";

export const OrdersPageContainer = styled('div')(() => ({
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    padding: '0 2.5rem',
}));
